var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ClientIcon, AffaireIcon, CollaborateurIcon, SearchIcon, } from '../../utils/Icons';
import { IconButton } from '../../utils/IconButton';
import { Button } from '../../utils/Button';
import { useState } from 'react';
import { Popover, Stack } from '@mui/material';
import { FormikGenerator, TYPES } from '../../utils/FormikGenerator';
export var SearchBar = function () {
    var _a = useState(null), anchor = _a[0], setAnchor = _a[1];
    var open = Boolean(anchor);
    var id = open ? 'search-popover' : undefined;
    var types = [
        {
            label: 'Collaborateur',
            id: 'collaborateur',
            options: 'collaborateurs',
            icon: _jsx(CollaborateurIcon, {}),
        },
        { label: 'Client', id: 'client', options: 'clients', icon: _jsx(ClientIcon, {}) },
        {
            label: 'Affaire',
            id: 'affaire',
            options: 'affaires',
            icon: _jsx(AffaireIcon, {}),
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ color: "white", onClick: function (e) { return setAnchor(e.currentTarget); }, tooltip: "Rechercher" }, { children: _jsx(SearchIcon, {}) })), _jsx(Popover, __assign({ id: id, open: open, anchorEl: anchor, onClose: function () { return setAnchor(null); }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                } }, { children: _jsx(FormikGenerator, { fields: [], datas: {
                        type: types[1],
                    }, additionalInitialValues: ['type'], renderSubmit: function () { }, renderContent: function (_a) {
                        var values = _a.values, renderField = _a.renderField, setFieldValue = _a.setFieldValue;
                        return (_jsxs(Stack, __assign({ padding: 2, spacing: 2 }, { children: [_jsx(Stack, __assign({ direction: "row", justifyContent: "center", alignItems: "center", spacing: 1 }, { children: types.map(function (type) { return (_jsx(Button, __assign({ color: values.type !== type ? 'disabled' : type.id, onClick: function () { return setFieldValue('type', type); }, startIcon: type.icon }, { children: type.label }), type.id)); }) })), values.type && (_jsx(Stack, { children: renderField({
                                        label: values.type.label,
                                        name: values.type.id,
                                        type: TYPES.SELECT,
                                        afterChange: function (value) {
                                            return (window.location.href = "/".concat(values.type.id, "/fiche/").concat(value));
                                        },
                                        asyncOptions: values.type.options,
                                    }) }))] })));
                    }, onSubmit: function () { } }) }))] }));
};
//# sourceMappingURL=SearchBar.js.map